/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcChevronsRightLargeRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path d="M4.363 4.636a.9.9 0 1 1 1.273-1.272l8 8a.9.9 0 0 1 0 1.272l-8 8a.9.9 0 0 1-1.273-1.272L11.727 12z" />
      <path d="M12.363 4.636a.9.9 0 1 1 1.273-1.272l8 8a.9.9 0 0 1 0 1.272l-8 8a.9.9 0 0 1-1.273-1.272L19.727 12z" />
    </svg>
  );
}
export default IcChevronsRightLargeRegular;
